"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertPopup = exports.AlertLevel = void 0;
var theme_ui_1 = require("theme-ui");
var __1 = require("../../..");
var alert_svg_1 = __importDefault(require("../../styles/Icons/assets/alert.svg"));
var AlertLevel;
(function (AlertLevel) {
    AlertLevel["WARNING"] = "warning";
    AlertLevel["ERROR"] = "error";
})(AlertLevel = exports.AlertLevel || (exports.AlertLevel = {}));
function AlertPopup(_a) {
    var _b = _a.role, role = _b === void 0 ? "alert" : _b, _c = _a.bgColor, bgColor = _c === void 0 ? __1.theme.colors.warningRed : _c, children = _a.children, message = _a.message, _d = _a.isCloseable, isCloseable = _d === void 0 ? false : _d, onClose = _a.onClose;
    return (theme_ui_1.jsx(theme_ui_1.Box, { role: role, bg: bgColor, sx: { my: "20px" } },
        theme_ui_1.jsx(theme_ui_1.Flex, null,
            theme_ui_1.jsx(theme_ui_1.Box, { p: 2, sx: { alignSelf: "center" } },
                theme_ui_1.jsx(__1.Image, { src: alert_svg_1.default, title: "Alert", alt: "Alert" })),
            theme_ui_1.jsx(theme_ui_1.Box, { p: 2, sx: { flex: "1 1 auto" } },
                theme_ui_1.jsx(__1.Text, { as: "p", sx: { m: "revert" } }, children || message)),
            isCloseable && (theme_ui_1.jsx(__1.Close, { title: "Close", onClick: onClose, csx: {
                    margin: "10px",
                    ":hover": {
                        backgroundColor: "white",
                    },
                } })))));
}
exports.AlertPopup = AlertPopup;
